import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { KratosConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class KratosApiModule {
    public static forRoot(configurationFactory: () => KratosConfiguration): ModuleWithProviders<KratosApiModule> {
        return {
            ngModule: KratosApiModule,
            providers: [ { provide: KratosConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: KratosApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('KratosApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
